"use strict"; // Copyright 2014-2016, Google, Inc.
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//    http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var _regeneratorRuntime = require("/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var fs = require("fs");

var google_auth_library_1 = require("google-auth-library");

var pify = require("pify");

var url = require("url");

var util = require("util");

var apirequest_1 = require("./apirequest");

var endpoint_1 = require("./endpoint");

var fsp = pify(fs);

var Discovery =
/*#__PURE__*/
function () {
  /**
   * Discovery for discovering API endpoints
   *
   * @param options Options for discovery
   */
  function Discovery(options) {
    _classCallCheck(this, Discovery);

    this.transporter = new google_auth_library_1.DefaultTransporter();
    this.options = options || {};
  }
  /**
   * Generate and Endpoint from an endpoint schema object.
   *
   * @param schema The schema from which to generate the Endpoint.
   * @return A function that creates an endpoint.
   */


  _createClass(Discovery, [{
    key: "makeEndpoint",
    value: function makeEndpoint(schema) {
      return function (options) {
        var ep = new endpoint_1.Endpoint(options);
        ep.applySchema(ep, schema, schema, ep);
        return ep;
      };
    }
    /**
     * Log output of generator. Works just like console.log
     */

  }, {
    key: "log",
    value: function log() {
      if (this.options && this.options.debug) {
        var _console;

        (_console = console).log.apply(_console, arguments);
      }
    }
    /**
     * Generate all APIs and return as in-memory object.
     * @param discoveryUrl
     */

  }, {
    key: "discoverAllAPIs",
    value: function () {
      var _discoverAllAPIs = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(discoveryUrl) {
        var _this = this;

        var headers, res, items, apis, versionIndex, apisIndex, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                headers = this.options.includePrivate ? {} : {
                  'X-User-Ip': '0.0.0.0'
                };
                _context2.next = 3;
                return this.transporter.request({
                  url: discoveryUrl,
                  headers: headers
                });

              case 3:
                res = _context2.sent;
                items = res.data.items;
                _context2.next = 7;
                return Promise.all(items.map(
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee(api) {
                    var endpointCreator;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _this.discoverAPI(api.discoveryRestUrl);

                          case 2:
                            endpointCreator = _context.sent;
                            return _context.abrupt("return", {
                              api: api,
                              endpointCreator: endpointCreator
                            });

                          case 4:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 7:
                apis = _context2.sent;
                versionIndex = {}; // tslint:disable-next-line no-any

                apisIndex = {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 13;

                _loop = function _loop() {
                  var set = _step.value;

                  if (!apisIndex[set.api.name]) {
                    versionIndex[set.api.name] = {};

                    apisIndex[set.api.name] = function (options) {
                      var type = typeof options;
                      var version;

                      if (type === 'string') {
                        version = options;
                        options = {};
                      } else if (type === 'object') {
                        version = options.version;
                        delete options.version;
                      } else {
                        throw new Error('Argument error: Accepts only string or object');
                      }

                      try {
                        var ep = // tslint:disable-next-line: no-any
                        set.endpointCreator(options, _this);
                        return Object.freeze(ep); // create new & freeze
                      } catch (e) {
                        throw new Error(util.format('Unable to load endpoint %s("%s"): %s', set.api.name, version, e.message));
                      }
                    };
                  }

                  versionIndex[set.api.name][set.api.version] = set.endpointCreator;
                };

                for (_iterator = apis[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  _loop();
                }

                _context2.next = 22;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](13);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 22:
                _context2.prev = 22;
                _context2.prev = 23;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 25:
                _context2.prev = 25;

                if (!_didIteratorError) {
                  _context2.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context2.finish(25);

              case 29:
                return _context2.finish(22);

              case 30:
                return _context2.abrupt("return", apisIndex);

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[13, 18, 22, 30], [23,, 25, 29]]);
      }));

      function discoverAllAPIs(_x) {
        return _discoverAllAPIs.apply(this, arguments);
      }

      return discoverAllAPIs;
    }()
    /**
     * Generate API file given discovery URL
     *
     * @param apiDiscoveryUrl URL or filename of discovery doc for API
     * @returns A promise that resolves with a function that creates the endpoint
     */

  }, {
    key: "discoverAPI",
    value: function () {
      var _discoverAPI = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(apiDiscoveryUrl) {
        var parts, file, res, options, _url, parameters, pcr, _res;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(typeof apiDiscoveryUrl === 'string')) {
                  _context3.next = 17;
                  break;
                }

                parts = url.parse(apiDiscoveryUrl);

                if (!(apiDiscoveryUrl && !parts.protocol)) {
                  _context3.next = 10;
                  break;
                }

                this.log('Reading from file ' + apiDiscoveryUrl);
                _context3.next = 6;
                return fsp.readFile(apiDiscoveryUrl, {
                  encoding: 'utf8'
                });

              case 6:
                file = _context3.sent;
                return _context3.abrupt("return", this.makeEndpoint(JSON.parse(file)));

              case 10:
                this.log('Requesting ' + apiDiscoveryUrl);
                _context3.next = 13;
                return this.transporter.request({
                  url: apiDiscoveryUrl
                });

              case 13:
                res = _context3.sent;
                return _context3.abrupt("return", this.makeEndpoint(res.data));

              case 15:
                _context3.next = 27;
                break;

              case 17:
                options = apiDiscoveryUrl;
                this.log('Requesting ' + options.url);
                _url = options.url;
                delete options.url;
                parameters = {
                  options: {
                    url: _url,
                    method: 'GET'
                  },
                  requiredParams: [],
                  pathParams: [],
                  params: options,
                  context: {
                    google: {
                      _options: {}
                    },
                    _options: {}
                  }
                };
                pcr = pify(apirequest_1.createAPIRequest);
                _context3.next = 25;
                return pcr(parameters);

              case 25:
                _res = _context3.sent;
                return _context3.abrupt("return", this.makeEndpoint(_res.data));

              case 27:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function discoverAPI(_x3) {
        return _discoverAPI.apply(this, arguments);
      }

      return discoverAPI;
    }()
  }]);

  return Discovery;
}();

exports.Discovery = Discovery;